import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { featuredTestimonial, testimonials } from '../../data/testimonials';
type Testimonial = {
  author: string;
  quote: string;
};
function ReviewCard({
  item,
  hidden
}: {
  item: Testimonial;
  hidden: boolean;
}) {
  return <li aria-hidden={hidden} className="flex w-[320px] shrink-0 flex-col rounded-2xl bg-white p-6 sm:w-[380px]" data-id="element-133" data-mp="1sozd0wq6q8ua">
      <p className="text-[15px] leading-relaxed text-ink" data-id="element-134" data-mp="2ggmuko1k47jw">« {item.quote} »</p>
      <p className="mt-auto pt-5 text-sm font-semibold text-fog-dark" data-id="element-135" data-mp="2leod97v2m4uu">{item.author}</p>
    </li>;
}
export function TestimonialsSection() {
  const half = Math.ceil(testimonials.length / 2);
  const rows = [testimonials.slice(0, half), testimonials.slice(half)];
  return <section aria-labelledby="reviews-title" className="w-full overflow-hidden bg-lime text-ink" data-id="element-136" data-mp="2ze7i9rsl502x">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 pb-16 pt-24 sm:px-8 lg:grid-cols-12 lg:pt-32" data-id="element-137" data-mp="344wefkf7ml8e">
        <div className="lg:col-span-4" data-id="element-138" data-mp="15kj08kii52ld">
          <h2 id="reviews-title" className="font-display text-5xl font-bold leading-[0.95] tracking-tight sm:text-6xl" data-id="element-139" data-mp="15lkeexute57b">
            Ça roule pour eux !
          </h2>
          <div className="mt-6 flex items-center gap-1" aria-label="Avis clients 5 étoiles" data-id="element-140" data-mp="1fb3y25qcq338">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-ink text-ink" aria-hidden="true" data-id="element-141" data-mp="1aikk37nr55xw" data-mpi={i} />)}
          </div>
        </div>
        <motion.figure initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:col-span-8" data-id="element-142" data-mp="1k9ypfw2dwzyy">
          <blockquote className="font-display text-2xl font-medium leading-snug tracking-tight sm:text-4xl" data-id="element-143" data-mp="1t8agfz75xzrx">
            « {featuredTestimonial.quote} »
          </blockquote>
          <figcaption className="mt-6 text-sm font-semibold" data-id="element-144" data-mp="3v3azog608ni4">— {featuredTestimonial.author}</figcaption>
        </motion.figure>
      </div>

      <div className="marquee-group space-y-4 pb-24 lg:pb-32" data-id="element-145" data-mp="23xomn6folenh">
        {rows.map((row, r) => <ul key={r} className={`flex w-max gap-4 ${r === 0 ? 'animate-marquee' : 'animate-marquee-reverse'}`} data-id="element-146" data-mp="27z9ugddcz2qt" data-mpi={r}>
            {[...row, ...row].map((item, i) => <ReviewCard key={`${item.author}-${i}`} item={item} hidden={i >= row.length} data-id="element-147" data-mp="2czo2vwivgepd" data-mpi={i} />)}
          </ul>)}
      </div>
    </section>;
}